<div style="display: flex; flex-direction: row; flex-basis: 100%" data-cy="referral-config-container">
  <div style="display: flex; flex-direction: column; flex: 1; height: 92vh;" data-cy="referral-config-left-panel">
    <div style="flex-basis: fit-content; padding-left: 5px" data-cy="referral-config-provider-container">
      <app-tdo-dropdown placeholder="Provider"
                        [dataSource]="doctorList"
                        dataSourceDisplayKey="providerName"
                        [isObjectValue]="true"
                        [value]="currentProvider"
                        (selectionChange)="changeDr($event)"
                        cypressControlIdentifier="providerList"
                        data-cy="referral-config-provider-dropdown">
      </app-tdo-dropdown>
    </div>
    <div *ngIf="!referringDocs" data-cy="referral-config-no-doctors-message">No referring doctors for this user</div>
    <tdo-table *ngIf="referringDocs" #doctTable [dataSource]="referringDocs" isSearchable="false"
               style="display: flex; flex-direction: row; flex:1; margin: 1%" sortActive="name" sortDirection="asc"
               data-cy="referral-config-doctors-table">
      <tdo-table-column displayName="My Referring Doctors" propertyName="FullName" [rowTemplate]="FullName" data-cy="referral-config-doctors-name-column">
        <ng-template #FullName let-row>
          <span
            style="flex-basis: 80%; padding: 3px" data-cy="referral-config-doctor-name-{{row.index}}"><b>{{row.model.FullName != '' ? row.model.FullName : 'No name saved for this user'}}</b></span>
          <br>
          <ng-container>
            <span data-cy="referral-config-doctor-email-{{row.index}}">Email: {{row.model.email != '' ? row.model.email : 'No email saved for this user'}}</span><br>
            <span data-cy="referral-config-doctor-phone-{{row.index}}">Phone: {{row.model.phone != '' ? row.model.phone : 'No phone saved for this user'}}</span>
          </ng-container>
        </ng-template>
      </tdo-table-column>
    </tdo-table>
  </div>
  <div
    style="display: flex; flex-direction: column; flex: 3; padding: 0 1%; margin: 0 1%; background-color: white; height: 92vh"
    data-cy="referral-config-right-panel">
    <br/>
    <app-tdo-configuration-action-bar [isCustom]="true" data-cy="referral-config-action-bar">
      <button mat-button class="tdo-button tdo-save" (click)="createReferralFromSelected()"
              [attr.data-cy]="'CopyDoctorReferralsFromSelected'">Same as...
      </button>
    </app-tdo-configuration-action-bar>
    <div *ngIf="showSameAs" class='content' style="max-width: 300px" data-cy="referral-config-same-as-container">
      <app-tdo-dropdown placeholder="Provider"
                        [dataSource]="doctorList"
                        dataSourceDisplayKey="providerName"
                        [isObjectValue]="true"
                        [value]="copyFromSelectedProvider"
                        (selectionChange)="copyFromSelectedDr($event)"
                        cypressControlIdentifier="copyFromProviderList"
                        data-cy="referral-config-copy-provider-dropdown">
      </app-tdo-dropdown>
    </div>
    <!--Schedule Question!-->
    <tdo-table [label]="'Schedule questions'" *ngIf="schedule && schedule.length > 0" #referralScheduleTable
               [isSearchable]="false"
               [isAddButtonEnabled]="true" (addClicked)="createNewSchedule()"
               (rowSelected)="onRowSelectedSchedule($event)"
               cypressControlAddButtonIdentifier="buttonNewSchedule"
               [dataSource]="schedule" style="display: flex; flex-direction: row; flex:1; margin: 1%;height: 30%"
               data-cy="referral-config-schedule-table">
      <tdo-table-column displayName="Order" propertyName="iOrder" [rowTemplate]="iOrder" data-cy="referral-config-schedule-order-column">
        <ng-template #iOrder let-row>
          <div style="display: flex; max-width: 50px;" data-cy="referral-config-schedule-order-cell-{{row.index}}">
            <input [value]="row.model.iOrder"
                   matInput type="number"
                   (focusout)="this.selectedReferralSchedule.iOrder = $event.target.value; this.saveReferralSchedule(row, selectedReferralSchedule, 'Order');"
                   class="OrderStyle"
                   [attr.data-cy]="'scheduleOrderRow-' + row.index"/>
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Question" propertyName="ItemName" [rowTemplate]="name" data-cy="referral-config-schedule-question-column">
        <ng-template #name let-row>
          <div style="display: flex; width: 100%;" data-cy="referral-config-schedule-question-cell-{{row.index}}">
            <input [value]="row.model.ItemName" #focusSchedule
                   (focusout)="this.selectedReferralSchedule.ItemName = $event.target.value; this.saveReferralSchedule(row, selectedReferralSchedule, 'ItemName');"
                   class="inputStyle"
                   [attr.data-cy]="'scheduleQuestionRow-' + row.index"/>
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Description" propertyName="ItemDescription" [rowTemplate]="description" data-cy="referral-config-schedule-description-column">
        <ng-template #description let-row>
          <div style="display: flex; width: 100%;" data-cy="referral-config-schedule-description-cell-{{row.index}}">
            <input [value]="row.model.ItemDescription"
                   (focusout)="this.selectedReferralSchedule.ItemDescription = $event.target.value; this.saveReferralSchedule(row, selectedReferralSchedule, 'ItemDescription');"
                   class="inputStyle"
                   [attr.data-cy]="'scheduleDescriptionRow-' + row.index"/>
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Schedule Type" propertyName="enumReferralScheduleTypeID" isSortable="false"
                        [rowTemplate]="enumReferralScheduleTypeID" data-cy="referral-config-schedule-type-column">
        <ng-template #enumReferralScheduleTypeID let-row>
          <mat-form-field class="insurance-select" style="width:100%" floatLabel='never' data-cy="referral-config-schedule-type-field-{{row.index}}">
            <mat-label data-cy="referral-config-schedule-type-label-{{row.index}}">Schedule Type</mat-label>
            <mat-select [attr.data-cy]="'enumReferralScheduleType' + row.index"
                        [(value)]="row.model.enumReferralScheduleTypeID"
                        (selectionChange)="this.selectedReferralSchedule.enumReferralScheduleTypeID = $event.value; this.saveReferralSchedule(row, selectedReferralSchedule, 'enumReferralScheduleTypeID');">
              <mat-option *ngFor="let method of this.enumReferralScheduleType; let i = index"
                          [value]="method.ValidValueItemId"
                          [attr.data-cy]="'enumReferralScheduleType' + row.index + '-' + i">
                {{ method.ItemDisplayValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="" propertyName="xauditDeleted" [isSortable]="false" [rowTemplate]="actions" data-cy="referral-config-schedule-actions-column">
        <ng-template #actions let-row>
          <div [matTooltip]="'Delete ' + row.model.ItemName + '?'"
               class="deleteIcon"
               (click)="onDeleteSchedule(row, $event)" [attr.data-cy]="'deleteReferralScheduleRow-' + row.index">
            <mat-icon>delete</mat-icon>
          </div>
        </ng-template>
      </tdo-table-column>
    </tdo-table>
    <tdo-table [label]="'Schedule questions'" *ngIf="schedule && schedule.length <= 0" #referralScheduleTable
               [isSearchable]="false"
               [isAddButtonEnabled]="true" (addClicked)="createNewSchedule()"
               cypressControlAddButtonIdentifier="buttonNewSchedule"
               [dataSource]="schedule" style="display: flex; flex-direction: row; flex:1; margin: 1%"
               data-cy="referral-config-empty-schedule-table">
    </tdo-table>
    <!--Treatment List!-->
    <tdo-table [label]="'Treatment list that doctor offers'" *ngIf="procedures && procedures.length > 0"
               #referralTreatmentTable [isSearchable]="false"
               [isAddButtonEnabled]="true" (addClicked)="createNewTreatment()"
               (rowSelected)="onRowSelectedTreatment($event)"
               cypressControlAddButtonIdentifier="buttonNewTreatment"
               [dataSource]="procedures" style="display: flex; flex-direction: row; flex:1; margin: 1%; height: 30%"
               data-cy="referral-config-treatment-table">
      <tdo-table-column displayName="Order" propertyName="iOrder" [rowTemplate]="iOrder" data-cy="referral-config-treatment-order-column">
        <ng-template #iOrder let-row>
          <div style="display: flex; width: 100%;" data-cy="referral-config-treatment-order-cell-{{row.index}}">
            <input [value]="row.model.iOrder"
                   matInput type="number"
                   (focusout)="this.selectedReferralTreatment.iOrder = $event.target.value; this.saveReferralTreatment(row, selectedReferralTreatment, 'Order');"
                   class="OrderStyle"
                   [attr.data-cy]="'treatmentOrderRow-' + row.index"/>
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Treatment" propertyName="ItemName" [rowTemplate]="name" data-cy="referral-config-treatment-name-column">
        <ng-template #name let-row>
          <div style="display: flex; width: 100%;" data-cy="referral-config-treatment-name-cell-{{row.index}}">
            <input [value]="row.model.ItemName" #focusTreatment
                   (focusout)="this.selectedReferralTreatment.ItemName = $event.target.value; this.saveReferralTreatment(row, selectedReferralTreatment, 'ItemName');"
                   class="inputStyle"
                   [attr.data-cy]="'treatmentRow-' + row.index"/>
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Description" propertyName="ItemDescription" [rowTemplate]="description" data-cy="referral-config-treatment-description-column">
        <ng-template #description let-row>
          <div style="display: flex; width: 100%;" data-cy="referral-config-treatment-description-cell-{{row.index}}">
            <input [value]="row.model.ItemDescription"
                   (focusout)="this.selectedReferralTreatment.ItemDescription = $event.target.value; this.saveReferralTreatment(row, selectedReferralTreatment, 'ItemDescription');"
                   class="inputStyle"
                   [attr.data-cy]="'treatmentDescriptionRow-' + row.index"/>
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="" propertyName="xauditDeleted" [isSortable]="false" [rowTemplate]="actions" data-cy="referral-config-treatment-actions-column">
        <ng-template #actions let-row>
          <div [matTooltip]="'Delete ' + row.model.ItemName + '?'"
               class="deleteIcon"
               (click)="onDeleteTreatment(row, $event)" [attr.data-cy]="'deleteReferralTreatmentRow-' + row.index">
            <mat-icon>delete</mat-icon>
          </div>
        </ng-template>
      </tdo-table-column>
    </tdo-table>
    <tdo-table [label]="'Treatment list that doctor offers'" *ngIf="procedures && procedures.length <= 0"
               #referralTreatmentTable [isSearchable]="false"
               [isAddButtonEnabled]="true" (addClicked)="createNewTreatment()"
               cypressControlAddButtonIdentifier="buttonNewTreatment"
               [dataSource]="procedures" style="display: flex; flex-direction: row; flex:1; margin: 1%"
               data-cy="referral-config-empty-treatment-table">
    </tdo-table>
    <!--Other Services!-->
    <tdo-table [label]="'Other services that the doctor offers'" *ngIf="otherServices && otherServices.length > 0"
               #referralOtherServiceTable [isSearchable]="false"
               [isAddButtonEnabled]="true" (addClicked)="createNewService()"
               (rowSelected)="onRowSelectedOtherService($event)"
               cypressControlAddButtonIdentifier="buttonNewService"
               [dataSource]="otherServices" style="display: flex; flex-direction: row; flex:1; margin: 1%; height: 30%"
               data-cy="referral-config-services-table">
      <tdo-table-column displayName="Order" propertyName="iOrder" [rowTemplate]="iOrder" data-cy="referral-config-services-order-column">
        <ng-template #iOrder let-row>
          <div style="display: flex; width: 100%;" data-cy="referral-config-services-order-cell-{{row.index}}">
            <input [value]="row.model.iOrder"
                   matInput type="number"
                   (focusout)="this.selectedReferralOtherService.iOrder = $event.target.value; this.saveReferralOtherService(row, selectedReferralOtherService, 'Order');"
                   class="OrderStyle"
                   [attr.data-cy]="'otherServiceOrderRow-' + row.index"/>
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Service" propertyName="ItemName" [rowTemplate]="name" data-cy="referral-config-services-name-column">
        <ng-template #name let-row>
          <div style="display: flex; width: 100%;" data-cy="referral-config-services-name-cell-{{row.index}}">
            <input [value]="row.model.ItemName" #focusOtherService
                   (focusout)="this.selectedReferralOtherService.ItemName = $event.target.value; this.saveReferralOtherService(row, selectedReferralOtherService, 'ItemName');"
                   class="inputStyle"
                   [attr.data-cy]="'otherServiceRow-' + row.index"/>
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Description" propertyName="ItemDescription" [rowTemplate]="description" data-cy="referral-config-services-description-column">
        <ng-template #description let-row>
          <div style="display: flex; width: 100%;" data-cy="referral-config-services-description-cell-{{row.index}}">
            <input [value]="row.model.ItemDescription"
                   (focusout)="this.selectedReferralOtherService.ItemDescription = $event.target.value; this.saveReferralOtherService(row, selectedReferralOtherService, 'ItemDescription');"
                   class="inputStyle"
                   [attr.data-cy]="'otherServiceDescriptionRow-' + row.index"/>
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="" propertyName="xauditDeleted" [isSortable]="false" [rowTemplate]="actions" data-cy="referral-config-services-actions-column">
        <ng-template #actions let-row>
          <div [matTooltip]="'Delete ' + row.model.ItemName + '?'"
               class="deleteIcon"
               (click)="onDeleteOtherService(row, $event)"
               [attr.data-cy]="'deleteReferralOtherServiceRow-' + row.index">
            <mat-icon>delete</mat-icon>
          </div>
        </ng-template>
      </tdo-table-column>
    </tdo-table>
    <tdo-table [label]="'Other services that the doctor offers'" *ngIf="otherServices && otherServices.length <= 0"
               #referralOtherServiceTable [isSearchable]="false"
               [isAddButtonEnabled]="true" (addClicked)="createNewService()"
               cypressControlAddButtonIdentifier="buttonNewService"
               [dataSource]="otherServices" style="display: flex; flex-direction: row; flex:1; margin: 1%"
               data-cy="referral-config-empty-services-table">
    </tdo-table>
  </div>
</div>

